import { ProductBidStatus } from "@simplyk/common";

import { AuctionBidBadge } from "./AuctionBidBadgeChip";

export function computeBidBadge({
  userHasServerBid,
  closed,
  userBidStatus,
  userIsTopBidder,
}: {
  userHasServerBid: boolean;
  closed: boolean;
  userBidStatus: ProductBidStatus | undefined;
  userIsTopBidder: boolean;
}): AuctionBidBadge | undefined {
  if (!userHasServerBid) {
    return undefined;
  }
  if (userBidStatus === ProductBidStatus.Won) {
    return "won";
  }
  if (userBidStatus === ProductBidStatus.Lost) {
    return "lost";
  }
  if (closed) {
    return userIsTopBidder ? "won" : "lost";
  }
  return userIsTopBidder ? "isWinning" : "isOutbid";
}
